import { Component, OnInit, ViewChild, ViewEncapsulation } from "@angular/core";
import { ApplicationFormBase } from "../../../shared/data-objects/application-form-base";
import { LoginService } from "../../../shared/services/login.service";
import { Psa } from "../psa";
import { SelectItem, Steps } from "primeng/primeng";
import * as MenuUtils from "../../../shared/data-objects/menu-item-ex";
import { PsaService } from "../psa.service";
import { Router } from "@angular/router";

import { UploadfilesViewmodel } from "../../../shared/viewmodels/uploadfiles-viewmodel";
import { AddressDetails2Component } from "../../../shared/components/address-details2/address-details2.component";
import { ApplicantDetails2Component } from "../../../shared/components/applicant-details2/applicant-details2.component";
import { WorkrequestPsaComponent } from "../workrequest-psa/workrequest-psa.component";
import { OwnerDetails2Component } from "../../../shared/components/owner-details2/owner-details2.component";
import { ConsultantDetailsComponent } from "../../../shared/components/consultant-details/consultant-details.component";
import { FormControl, Validators } from "@angular/forms";
import { UploadFile2Component } from "../../../shared/components/upload-file2/upload-file2.component";
import { DisclaimerPsaComponent } from "../disclaimer-psa/disclaimer-psa.component";
import { ServiceBase } from "../../../shared/services/service-base";

Steps.prototype.itemClick = MenuUtils.itemClick;

@Component({
  selector: "app-psa",
  templateUrl: "./psa.component.html",
  styleUrls: ["./psa.component.css"],
  encapsulation: ViewEncapsulation.None,
})
export class PsaComponent extends ApplicationFormBase<Psa> implements OnInit {
  isRequesting: boolean;
  inLinePumpUploadPlan: boolean;
  selectedPlan: any;
  planTypeList: any[] = [];
  fileToUpload: File[] = null;
  isInstallationNumberValid: boolean = true;

  greenFieldrequiredControl: FormControl;
  brownFieldrequiredControl: FormControl;
  errorMessageMain: any[] = [];
  greenField: boolean = false;
  brownField: boolean = false;

  locationConfirm: boolean;
  ownerConfirm: boolean;
  developerConfirm: boolean;
  applicantConfirm: boolean;
  correspondenceConfirm: boolean;
  developmentConfirm: boolean;
  lotsConfirm: boolean;
  plansConfirm: boolean;
  cwwConfirm: boolean;

  waterServicesConfirm: boolean;
  inLineWaterConfirm: boolean;
  inLineWaterConfirmDetail: boolean;

  recycleServicesConfirm: boolean;
  inLineRecycleConfirm: boolean;
  inLineRecycleConfirmDetail: boolean;

  sewerServicesConfirm: boolean;
  assetProtectionConfirm: boolean;
  basementsConfirm: boolean;

  displayPlanMessageDialog: boolean = false;

  @ViewChild("address") address: AddressDetails2Component;
  @ViewChild("applicant2") applicant2: ApplicantDetails2Component;
  @ViewChild("workRequestPsa") workRequestPsa: WorkrequestPsaComponent;
  @ViewChild("owner2") owner2: OwnerDetails2Component;
  @ViewChild("consultant") consultant: ConsultantDetailsComponent;
  @ViewChild("uploadComponent") uploadComponent: UploadFile2Component;
  @ViewChild("disclaimer") disclaimerComponent: DisclaimerPsaComponent;

  constructor(
    private psaService: PsaService,
    protected loginService: LoginService,
    protected router: Router
  ) {
    super(psaService, loginService, null, router);
    this.greenFieldrequiredControl = new FormControl();
    this.brownFieldrequiredControl = new FormControl();

    this.psaService.onValidateInstallationNumber.subscribe((v) => {
      if (v === "valid" || v === "") {
        this.isInstallationNumberValid = true;
      } else {
        this.isInstallationNumberValid = false;
      }
    });

    this.psaService.serverError.subscribe(m=>{
      if(m)
      {
        this.errorMessageMain=[m]
      }

      else
      this.errorMessageMain=[]
    })
  }

  async ngOnInit() {
    let isTokenValid = await this.loginService.isTokenValid();
    if(!isTokenValid) {
      if(this.loginService.isGuestUserLoggedIn()) {
        this.loginService.guestLogin((ok: boolean)=>{
          this.setupTabs();
        });
      } else {
        this.router.navigate(['/login']);
      }
    } else {
      await this.loginService.refreshToken();
      this.setupTabs();
    }
  }

  setupTabs(): void {
    const me = this;

    // if (!this.loginService.isGuestUserLoggedIn()) {
    if (this.loginService.isUserBillLater()) {
      this.setApplicantDetailsForBillLater(this.psaService.applicationData.applicant);
    } else {
      // this.setApplicantDetailsForGuestUser(this.usrService.applicationData.applicant);
      this.setApplicantDetailsForNonBillLater(this.psaService.applicationData.applicant);
    }
    
    this.addMenuItem("Criteria", me, 0, "Pre Step");
    this.addMenuItem("Checklist", me, 1, "First Step");
    this.addMenuItem("Disclaimer", me, 2, "Second Step");
    this.addMenuItem("Property details", me, 3, "Third Step");
    this.addMenuItem("Applicant details", me, 4, "Fourth Step");
    //this.addMenuItem("Owner Details", me, 5, "Fifth Step");
   // this.addMenuItem("Consultant Details", me, 6, "Sixth Step");
    // this.addMenuItem('Correspondence', me, 6, 'Seventh Step');
    this.addMenuItem("Work request", me, 5, "Fifth Step");
    this.addMenuItem("Upload Files", me, 6, "Sixth Step");
    this.addMenuItem("Review and submit", me, 7, "Seventh Step");
    // }
  }

  validateCheckList() {
    if (this.psaService.applicationData.planType === "GreenField") {
      if (
        this.locationConfirm &&
        this.ownerConfirm &&
        this.developerConfirm &&
        this.applicantConfirm &&
        this.correspondenceConfirm &&
        this.developmentConfirm &&
        this.lotsConfirm &&
        this.plansConfirm
      )
        return true;
    }

    if (this.psaService.applicationData.planType === "BrownField") {
      if (
        this.locationConfirm &&
        this.ownerConfirm &&
        this.developerConfirm &&
        this.applicantConfirm &&
        this.correspondenceConfirm &&
        this.developmentConfirm &&
        this.plansConfirm &&
        this.waterServicesConfirm &&
        this.sewerServicesConfirm
      )
        return true;
    }

    return false;
  }

  clearChecklist() {
    this.locationConfirm = false;
    this.ownerConfirm = false;
    this.developerConfirm = false;
    this.applicantConfirm = false;
    this.correspondenceConfirm = false;
    this.developmentConfirm = false;
    this.plansConfirm = false;
    this.waterServicesConfirm = false;
    this.sewerServicesConfirm = false;
    this.inLineWaterConfirmDetail = false;
    this.recycleServicesConfirm = false;
    this.inLineRecycleConfirmDetail = false;
    this.lotsConfirm = false;
    this.plansConfirm = false;
  }

  renderCheckList(v) {
    this.clearChecklist();
    this.planTypeList = [];
    this.errorMessageMain = [];

    if (v === "GreenField") {
      this.psaService.applicationData.applicationType = "SRAGF";
      this.greenField = true;
      this.brownField = false;
    }
    if (v === "BrownField") {
      this.psaService.applicationData.applicationType = "SRABF";
      this.greenField = false;
      this.brownField = true;
    }
  }
  getTotalOrderAmount(): number {
    return null;
  }

  get shouldDisplayNextButton(): boolean {
    return this.activeIndex !== 9;
  }

  canGoNext(executeYes: any, executeNo: any): void {
    if (this.activeIndex === 0) {
      executeYes();
    } else if (this.activeIndex === 1) {
      if (
        this.brownFieldrequiredControl.touched ||
        this.greenFieldrequiredControl.touched
      ) {
        // if (!this.validateCheckList()) {
        //   this.errorMessageMain = ["Please confirm the mandatory fields"];
        //   executeNo();
        //   return;
        // }
        this.errorMessageMain = [];
        executeYes();
      } else {
        executeNo();
        this.errorMessageMain = ["Please select the plan type"];
        return;
      }
    } else if (this.activeIndex === 2) {
      if (this.disclaimerComponent.invalid) {
        this.errorMessageMain = [
          "Please confirm that you have agreed and read all the information above",
        ];
        executeNo();
        return;
      } else {
        this.errorMessageMain = [];
        executeYes();
      }
    } else if (this.activeIndex === 3) {
      if (this.address.invalid) {
        this.address.displayErrorMessage();
        executeNo();
        return;
      }

      if (!this.isInstallationNumberValid) {
        this.address.errorMessage = [];
        this.address.errorMessage = ["Installation number not found"];
        executeNo();
        return;
      } else {
        this.address.errorMessage = [];
        executeYes();
      }
    } else if (this.activeIndex === 4) {
      this.applicant2.errorMessage = null;
      if (
        this.applicant2.invalid &&
        this.applicant2.displayErrorMessage().length > 0
      ) {
        this.applicant2.displayErrorMessage();
        executeNo();
        return;
      } else {
        executeYes();
      }
   // } else if (this.activeIndex === 5) {
     // this.owner2.errorMessage = null;
      //if (this.owner2.invalid) {
     //   this.owner2.displayErrorMessage();
    //    executeNo();
    //    return;
    //  } else {
    //     executeYes();
    //   }
    // } else if (this.activeIndex === 6) {
    //   this.consultant.errorMessage = null;
    //   if (
    //     this.consultant.invalid &&
    //     this.consultant.displayErrorMessage().length > 0
    //   ) {
    //     this.consultant.displayErrorMessage();
    //     executeNo();
    //     return;
    //   } else {
    //     executeYes();
    //   }
    } else if (this.activeIndex === 5) {
      this.psaService.inLinePumpsSelected.next(
        this.workRequestPsa.inLinePumpList
      );

      this.workRequestPsa.errorMessage = null;
      if (
        this.workRequestPsa.invalid &&
        this.workRequestPsa.displayErrorMessage().length > 0
      ) {
        this.workRequestPsa.displayErrorMessage();
        executeNo();
        return;
      } else {
        executeYes();
      }
    } else if (this.activeIndex === 6) {
      if (this.uploadComponent.isInvalid()) {
        executeNo();
        return;
      } else {
        executeYes();
      }
    }
  }

  submitApplication(callback: any): void {
    this.psaService.serverError.next('')
    this.isRequesting = true;
    this.psaService.applicationData.propertyDetails = ServiceBase.sanitize(this.address.addressData);
    
        // sanitize method is used to allow special characters
    this.psaService.applicationData.applicant = ServiceBase.sanitize(this.applicant2.applicantDetails);
    // this.psaService.applicationData.owner =  ServiceBase.sanitize(this.owner2.ownerDetails);
    // this.psaService.applicationData.consultant =  ServiceBase.sanitize(this.consultant.consultantDetails);
    this.applicationService.applicationData.consumerNo = this.loginService.getUser().accountNumber;

    this.applicationService.applicationData.isGuestUser = this.loginService.getUser().isGuestUser;

    if (this.psaService.applicationData.planType === "BrownField") {
      let inLinePumpList = JSON.parse(
        JSON.stringify(this.workRequestPsa.inLinePumpList)
      );

      this.psaService.applicationData.workRequestPsa.description = ServiceBase.sanitizeString(
        this.psaService.applicationData.workRequestPsa.description
      );

      

      if (this.workRequestPsa.inLinePumpList) {
        inLinePumpList.map((x) => {
          let pumpCurve = this.workRequestPsa.pumpCurveOptions.find(
            (y) => y.display === x.pumpCurve
          );
          x.pumpCurve = pumpCurve.id;
          let waterSupplyOptions = this.workRequestPsa.waterSupplyOptions.find(
            (y) => y.display === x.purposeWaterSupply
          );
          x.purposeWaterSupply = waterSupplyOptions.id;
        });
      }

      this.psaService.applicationData.workRequestPsa.potableWaterServices.inlinePumps = inLinePumpList;

      this.psaService.applicationData.workRequestPsa.developmentType = this.psaService.applicationData.workRequestPsa.developmentType.replace(
        /[^a-zA-Z0-9]/g,
        ""
      );
      this.psaService.applicationData.workRequestDetails = this.psaService.applicationData.workRequestPsa;
    }

    if (this.psaService.applicationData.planType === "GreenField") {
      this.psaService.applicationData.workrequestGreenField.developmentType = this.psaService.applicationData.workrequestGreenField.developmentType.replace(
        /[^a-zA-Z0-9]/g,
        ""
      );
      this.psaService.applicationData.workRequestDetails = this.psaService.applicationData.workrequestGreenField;
    }

    this.doSubmit(callback);
  }

  private doSubmit(callback): void {
    this.executeSubmit(
      "SRA",
      callback,
      null,
      null,
      false,
      this.uploadComponent
    );
  }

  goNext(): void {
    this.canGoNext(
      () => {
        this.initMessages();
        this.activeIndex++;
      },
      () => {}
    );
  }

  canGoPrevious(): boolean {
    if (this.activeIndex === 0) {
      return false;
    }

    return true;
  }

  goPrevious(): void {
    if (!this.canGoPrevious()) {
      return;
    }

    this.initMessages();
    this.activeIndex--;
  }

  initMessages(): void {
    this.errorMessageMain = [];
  }

  get controlLabel(): string {
    return "Upload plans";
  }

  get uploadfilesViewmodel(): UploadfilesViewmodel {
    return this.psaService.uploadfilesViewmodel;
  }

  get shouldDisplayLocation(): boolean {
    return this.activeIndex === 3;
  }

  get shouldDisplayDisclaimer(): boolean {
    return this.activeIndex === 2;
  }
  get shouldDisplaySPAApplicationCriteria(): boolean {
    return this.activeIndex === 0;
  }
  get shouldDisplayCheckList(): boolean {
    return this.activeIndex === 1;
  }
  get shouldDisplayApplicant(): boolean {
    return this.activeIndex === 4;
  }
//  get shouldDisplayOwner(): boolean {
 //   return this.activeIndex === 5;
//  }

  get shouldDisplayWork(): boolean {
    return this.activeIndex === 5;
  }

//  get shouldDisplayDeveloper(): boolean {
 //   return this.activeIndex === 6;
 // }

  get shouldDisplayUploadFiles(): boolean {
    return this.activeIndex === 6;
  }

  get shouldShowSubmitAndReview(): boolean {
    return this.activeIndex === 7;
  }

  set planType(v: string) {
    this.psaService.applicationData.planType = v;
    this.renderCheckList(v);
    this.psaService.onDevelopmentChange.next(v);
  }

  get propertyDetails() {
    return this.psaService.applicationData.propertyDetails;
  }

  get applicantDetails2ViewModel() {
    return this.psaService.applicationData.applicant;
  }

  get workRequestPsaModel() {
    return this.psaService.applicationData.workRequestPsa;
  }

  get workrequestGreenField() {
    return this.psaService.applicationData.workrequestGreenField;
  }

  get ownerDetails() {
    return this.psaService.applicationData.owner;
  }

  get consultantDetails() {
    return this.psaService.applicationData.consultant;
  }
}



// WEBPACK FOOTER //
// ./src/app/create-application/psa-form/psa/psa.component.ts